export const getPossibleNotifications = translations => {
    return {
        'integrityCheck': translations["integrity_check"] || 'Integrity check',
        'erasureReportReady': translations["erasure_report_ready"] || 'Erasure report ready',
        'colliFinished': translations["colli_finished"] || 'Colli finished',
        'erasureFailed': translations["erasure_failed"] || 'Erasure failed',
        'licenseExpiration': translations["license_expiration"] || 'License expiration',
        'releaseNotes': translations['release_notes'] || 'Release notes',
        'errorMail': translations['general_errors'] || 'General errors',
        'billingFailed': translations['billing_failed'] || 'Billing failed',
        'requestBlocked': translations['request_blocked'] || 'Request blocked',
        'newCustomer': translations['customer_created'] || 'Customer created',

    };
};
export const getFormattedPossibleNotifications = translations => {
    return [
        { value: 'integrityCheck', label: translations["integrity_check"] || 'Integrity check' },
        { value: 'erasureReportReady', label: translations["erasure_report_ready"] || 'Erasure report ready' },
        { value: 'colliFinished', label: translations["colli_finished"] || 'Colli finished' },
        { value: 'erasureFailed', label: translations["erasure_failed"] || 'Erasure failed' },
        { value: 'licenseExpiration', label: translations["license_expiration"] || 'License expiration' },
        { value: 'releaseNotes', label: translations['release_notes'] || 'Release notes' },
        { value: 'errorMail', label: translations['general_errors'] || 'General errors' },
        { value: 'billingFailed', label: translations['billing_failed'] || 'Billing failed' },
        { value: 'requestBlocked', label: translations['request_blocked'] || 'Request blocked' },
        { value: 'newCustomer', label: translations['customer_created'] || 'Customer created' }
    ];
};

